import styles from './footer.module.css'
import React from 'react'
import fb from '../../../images/fb.png'
import ig from '../../../images/ig.png'
import youtube from '../../../images/you.png'
// import twiter from '../twi.png'
import linkdin from '../../../images/lin.png'
import logo from '../../../images/logo.png'
import { NavLink } from 'react-router-dom'

function Footer() {
  return (
      <div className={styles.footerSection}>
        <div className="container">
          <div className={styles.footerContainer}>
            <div>
              <img className={styles.logoImage} src={logo} alt="Anuyog Institute Logo" />
            </div>
            <div>
              <div className={styles.footerBottom}>
                <div className={`text-start ${styles.footerInfo}`}>
                  <ul>
                    <h1 className={`text-dark ${styles.footerHeading}`}>COMPANY</h1>
                    <li className={styles.footerListItem}>
                      <NavLink
                          to="/consultancy"
                          className={({ isActive }) => (isActive ? 'main-active' : styles.footerLink)}
                          onClick={() => window.scrollTo(0, 0)}
                      >
                        Consultancy
                      </NavLink>
                    </li>
                    <li className={styles.footerListItem}>
                      <NavLink
                          to="/product"
                          className={({ isActive }) => (isActive ? 'main-active' : styles.footerLink)}
                          onClick={() => window.scrollTo(0, 0)}
                      >
                        Product
                      </NavLink>
                    </li>
                    <li className={styles.footerListItem}>
                      <NavLink
                          to="/workshop"
                          className={({ isActive }) => (isActive ? 'main-active' : styles.footerLink)}
                          onClick={() => window.scrollTo(0, 0)}
                      >
                        Institute
                      </NavLink>
                    </li>
                    <li className={styles.footerListItem}>
                      <NavLink
                          to="/disclaimer_and_Disclosure"
                          className={({ isActive }) => (isActive ? 'main-active' : styles.footerLink)}
                          onClick={() => window.scrollTo(0, 0)}
                      >
                        Disclaimer & Disclosures
                      </NavLink>
                    </li>
                    <li className={styles.footerListItem}>
                      <NavLink
                          to="/terms_and_condition"
                          className={({ isActive }) => (isActive ? 'main-active' : styles.footerLink)}
                          onClick={() => window.scrollTo(0, 0)}
                      >
                        Terms & Conditions
                      </NavLink>
                    </li>

                  </ul>
                  {/* <ul>
                    <h1 className='text-dark'>PRODUCTS</h1>
                    <li>
                      <NavLink
                        to="/product"
                        className={({ isActive }) => (isActive ? 'main-active' : '')}
                        onClick={() => {
                          window.scrollTo(0, 0);
                        }}
                      >
                        Amrit Pey
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/product"
                        className={({ isActive }) => (isActive ? 'main-active' : '')}
                        onClick={() => {
                          window.scrollTo(0, 0);
                        }}
                      >
                        Khand
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/product"
                        className={({ isActive }) => (isActive ? 'main-active' : '')}
                        onClick={() => {
                          window.scrollTo(0, 0);
                        }}
                      >
                        Jaggery
                      </NavLink>
                    </li>
                  </ul> */}
                  <ul>
                    <h1 className={`text-dark ${styles.footerHeading}`}>You’ve a question?</h1>

                    <li className={styles.footerListItem} >Reach out to us,</li>
                    <li className={styles.footerListItem}>Call or Whatsapp: +91 789-230-7418</li>
                    <li className={styles.footerListItem}>Email: theanuyoginstitute@gmail.com</li>

                  </ul>
                  <div className={styles.socialMedia}>
                    <h5 className={styles.socialMediaTitle} >Follow Us</h5>
                    <ul className={styles.socialList}>
                      <a href="https://www.youtube.com/@theanuyoginstitute"><li className={`${styles.socialItem} ${styles.footerListItem}`} ><img className={styles.socialIcon} src={youtube} alt="" /></li></a>
                      <a href="https://www.facebook.com/theanuyoginstitute/"><li className={`${styles.socialItem} ${styles.footerListItem}`}><img className={styles.socialIcon} src={fb} alt="" /></li></a>
                      <a href="https://www.instagram.com/theanuyoginstitute/"> <li className={`${styles.socialItem} ${styles.footerListItem}`}><img className={styles.socialIcon} src={ig} alt="" /></li></a>
                      <li className={`${styles.socialItem} ${styles.footerListItem}`}><a href="/public"><img  className={styles.socialIcon} src={linkdin} alt="" /></a></li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className={styles.footerTop}>
                <div className={styles.footerAddress}>
                  <div className={styles.footerAddressText}>
                    <h5 className={`text-start mb-2 mt-4`}>@ANUYOG {new Date().getFullYear()} All rights reserved.</h5>
                    <h5 className={`text-start mb-2 mt-4`}>
                      <strong>Disclaimer:</strong> We will not be providing any medical advice
                    </h5>
                  </div>
                  <div>
                    <h6 className={`text-start mb-2 mt-4`}>Designed and Developed by <a href="https://efsouls.com/" target='_blank' rel='noreferrer'>EFSOULS</a></h6>
                    <p className={styles.footerAddressText}>
                      <a href="https://efsouls.com/" target='_blank' rel='noreferrer'>www.efsouls.com</a>
                    </p>
                    <p className={styles.footerAddressText}>+91 988-677-1395</p>
                  </div>
                </div>

                {/* <div className="logo-image">
  <img src={logo} alt="" />
</div> */}


                {/* <div className="social-media">
  <ul className='social'>
    <li><a href="https://www.facebook.com/theanuyoginstitute/"><img src={fb} alt="" /></a></li>
    <li><a href="https://www.instagram.com/theanuyoginstitute/"><img src={ig} alt="" /></a></li>
    <li><a href="https://www.youtube.com/@theanuyoginstitute"><img src={youtube} alt="" /></a></li>
    <li><a href="/"><img src={twiter} alt="" /></a></li>
    <li><a href="/"><img src={linkdin} alt="" /></a></li>
  </ul>
</div> */}

              </div>
            </div>
          </div>
        </div>


      </div>
  )
}

export default Footer
